<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'ChartsdimensionBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      let showEchart = false
      let namenum = 0
      let legendData = []
      let seriesData = []
      let xData = []
      if (this.data) {
        seriesData = this.data.data
        xData = this.data.namex
      }
      if (xData) {
        if (xData.length > 0) {
          namenum = Math.floor(100 / (xData.length / 5))
          if (xData.length > 5) {
            showEchart = true
          } else {
            showEchart = false
          }
        }
      }

      let yData = {
        type: 'bar',
        // barWidth: 15,
        // barGap: 0.2, //柱间距离
        label: {
          //图形上的文本标签
          show: true,
          position: 'top',
          textStyle: {
            // color: '#a8aab0',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 10
          }
        }
      }
      if (seriesData) {
        for (let tempi in seriesData) {
          seriesData[tempi] = Object.assign(seriesData[tempi], yData)
        }
        legendData = seriesData.map((obj) => {
          return { name: obj.name }
        })
      }

      const option = {
        // backgroundColor: '#23243a',
        backgroundColor: '#fff',
        color: [
          '#667eea',
          '#19be6b',
          '#ff9a9e',
          '#fbc2eb',
          '#96e6a1',
          '#d4fc79',
          '#84fab0',
          '#8fd3f4',
          '#fccb90',
          '#d57eeb'
        ],
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          //提示框组件
          trigger: 'axis',
          formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}',
          axisPointer: {
            type: 'shadow'
            // label: {
            //   backgroundColor: '#6a7985'
            // }
          }
          // textStyle: {
          //   color: '#000',
          //   fontStyle: 'normal',
          //   fontFamily: '微软雅黑',
          //   fontSize: 12
          // }
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '3%',
          top: 85,
          // padding: '0 0 10 0',
          containLabel: true
        },
        legend: {
          //图例组件，颜色和名字
          // left: 10,
          x: '4%',
          top: '10%',
          itemGap: 16,
          itemWidth: 18,
          itemHeight: 10,
          data: legendData,
          textStyle: {
            color: '#a8aab0',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 12
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true, //坐标轴两边留白
            data: xData,
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
              margin: 15,
              textStyle: {
                color: '#90979c',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12
              },
              formatter: function (params) {
                // 显示最多10个字符，超出显示省略号
                if (params.length > 10) {
                  params = params.slice(0, 10) + '...'
                }
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 5 //一行显示几个字
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
            },
            axisTick: {
              //坐标轴刻度相关设置。
              show: false
            },
            axisLine: {
              //坐标轴轴线相关设置
              lineStyle: {
                color: '#000',
                opacity: 0.2
              }
            },
            splitLine: {
              //坐标轴在 grid 区域中的分隔线。
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitNumber: 5,
            axisLabel: {
              textStyle: {
                color: '#a8aab0',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#000'],
                opacity: 0.06
              }
            },
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 10) * 10
            },
            max: (value) => {
              return Math.ceil(value.max)
              // return Math.ceil(value.max / 100) * 100
            }
          }
        ],

        dataZoom: [
          {
            type: 'slider',
            realtime: true,
            start: 0,
            end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
            height: 5, //组件高度
            left: 5, //左边的距离
            right: 5, //右边的距离
            bottom: 10, //下边的距离
            show: showEchart, // 是否展示
            fillerColor: 'rgba(17, 100, 210, 0.42)', // 滚动条颜色
            borderColor: 'rgba(17, 100, 210, 0.12)',
            handleSize: 0, //两边手柄尺寸
            showDetail: false, //拖拽时是否展示滚动条两侧的文字
            zoomLock: true, //是否只平移不缩放
            moveOnMouseMove: false, //鼠标移动能触发数据窗口平移
            //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放

            //下面是自己发现的一个问题，当点击滚动条横向拖拽拉长滚动条时，会出现文字重叠，导致效果很不好，以此用下面四个属性进行设置，当拖拽时，始终保持显示六个柱状图，可结合自己情况进行设置。添加这个属性前后的对比见**图二**
            startValue: 0, // 从头开始。
            endValue: 6, // 最多六个
            minValueSpan: 6, // 放大到最少几个
            maxValueSpan: 6 //  缩小到最多几个
          },
          {
            type: 'inside', // 支持内部鼠标滚动平移
            start: 0,
            end: namenum,
            zoomOnMouseWheel: false, // 关闭滚轮缩放
            moveOnMouseWheel: true, // 开启滚轮平移
            moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
          }
        ],
        series: seriesData
        // series: [
        //   {
        //     name: '流入',

        //     data: [4.9, 7.3, 9.2, 5.6, 7.7, 5.6, 4.2, 3.6, 6, 6.4],
        //     type: 'bar',
        //     barWidth: 10,
        //     barGap: 0.2, //柱间距离
        //     label: {
        //       //图形上的文本标签
        //       normal: {
        //         show: true,
        //         position: 'top',
        //         textStyle: {
        //           color: '#a8aab0',
        //           fontStyle: 'normal',
        //           fontFamily: '微软雅黑',
        //           fontSize: 12
        //         }
        //       }
        //     }
        //     // itemStyle: {
        //     //   //图形样式
        //     //   normal: {
        //     //     barBorderRadius: [5, 5, 0, 0],
        //     //     color: new echarts.graphic.LinearGradient(
        //     //       0,
        //     //       0,
        //     //       0,
        //     //       1,
        //     //       [
        //     //         {
        //     //           offset: 1,
        //     //           color: 'rgba(127, 128, 225, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0.9,
        //     //           color: 'rgba(72, 73, 181, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0.31,
        //     //           color: 'rgba(0, 208, 208, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0.15,
        //     //           color: 'rgba(0, 208, 208, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0,
        //     //           color: 'rgba(104, 253, 255, 0.7)'
        //     //         }
        //     //       ],
        //     //       false
        //     //     )
        //     //   }
        //     // }
        //   },
        //   {
        //     name: '流出',
        //     type: 'bar',
        //     data: [2.9, 5, 4.4, 2.7, 5.7, 4.6, 1.2, 2.7, 4.8, 6.0],
        //     barWidth: 10,
        //     barGap: 0.2, //柱间距离
        //     label: {
        //       //图形上的文本标签
        //       normal: {
        //         show: true,
        //         position: 'top',
        //         textStyle: {
        //           color: '#a8aab0',
        //           fontStyle: 'normal',
        //           fontFamily: '微软雅黑',
        //           fontSize: 12
        //         }
        //       }
        //     }
        //     // itemStyle: {
        //     //   //图形样式
        //     //   normal: {
        //     //     barBorderRadius: [5, 5, 0, 0],
        //     //     color: new echarts.graphic.LinearGradient(
        //     //       0,
        //     //       0,
        //     //       0,
        //     //       1,
        //     //       [
        //     //         {
        //     //           offset: 1,
        //     //           color: 'rgba(127, 128, 225, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0.9,
        //     //           color: 'rgba(72, 73, 181, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0.25,
        //     //           color: 'rgba(226, 99, 74, 0.7)'
        //     //         },
        //     //         {
        //     //           offset: 0,
        //     //           color: 'rgba(253, 200, 106, 0.7)'
        //     //         }
        //     //       ],
        //     //       false
        //     //     )
        //     //   }
        //     // }
        //   }
        // ]
      }
      mychart.setOption(option)
    }
  }
}
</script>
